module.exports = __webpack_public_path__ + "media/landing_page/location-45755667.svg";